export default __webpack_public_path__ + "8cd90c040ec6cd336022a831a125697b.jpg";